import { Language } from '@/utils/language'
import _ from 'lodash'
import enUS from './en-US.json'
import zhCN from './zh-CN.json'
import idID from './id-ID.json'
import thTH from './th-TH.json'
import msMY from './ms-MY.json'
import esES from './es-ES.json'
import viVN from './vi-VN.json'

const locale: Record<Language, Record<string, string>> = {
  [Language.enUS]: enUS,
  [Language.zhCN]: zhCN,
  [Language.idID]: idID,
  [Language.thTH]: thTH,
  [Language.msMY]: msMY,
  [Language.esES]: esES,
  [Language.viVN]: viVN
}

const enLocale = locale[Language.enUS]
// export const enLocale = enUS as Record<string, string>

const setDefaultLocale = (locale: Record<string, string>) => {
  return {
    ...enLocale,
    ..._.fromPairs(
      _.toPairs(locale).map(([key, value]) => {
        if (!value) {
          return [key, enLocale[key] || '']
        }

        return [key, value]
      })
    )
  }
}

locale[Language.idID] = setDefaultLocale(locale[Language.idID])

locale[Language.thTH] = setDefaultLocale(locale[Language.thTH])

locale[Language.msMY] = setDefaultLocale(locale[Language.msMY])

export default locale

// 功能函数，用于动态导入区域设置数据
// export async function importLocaleData(locale: Language) {
//   switch (locale) {
//     case Language.enUS: {
//       const data = (await import('./en-US.json')).default
//       return data
//     }
//     case Language.zhCN: {
//       const data = (await import('./zh-CN.json')).default
//       const defaultData = setDefaultLocale(data)
//       return defaultData
//     }
//     case Language.idID: {
//       const data = (await import('./id-ID.json')).default
//       const defaultData = setDefaultLocale(data)
//       return defaultData
//     }
//     case Language.thTH: {
//       const data = (await import('./th-TH.json')).default
//       const defaultData = setDefaultLocale(data)
//       return defaultData
//     }
//     case Language.msMY: {
//       const data = (await import('./ms-MY.json')).default
//       const defaultData = setDefaultLocale(data)
//       return defaultData
//     }
//     default: {
//       const data = (await import('./en-US.json')).default
//       return data
//     }
//   }
// }
